export default "__VITE_ASSET__BUmai$YJ__"